module.exports = __webpack_public_path__ + "img/icon_dongle_active.da462c46.svg";